<template>
  <q-form ref="editForm">
    <c-card title="일반작업 상세정보" class="cardClassDetailForm no-margin">
      <template slot="card-button">
        <q-chip dense>
          작업인원수
          <q-avatar color="blue" text-color="white" class="workpermit-worker-info">
            {{workPermit.workers && workPermit.workers.length > 0 ? workPermit.workers.length : 0}}
          </q-avatar>
        </q-chip>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <!-- :afterIcon="isWriting ? [
              { name: 'mode_edit', click: true, callbackName: 'sopEdit', color: '' },
              { name: 'search', click: true, callbackName: 'searchSop', color: 'teal' },
              { name: 'close', click: true, callbackName: 'removeSop', color: 'red' }
            ] : null"
            @sopEdit="sopEdit"
            @searchSop="searchSop"
            @removeSop="removeSop" -->
          <c-text
            :required="true"
            :editable="editable"
            :disabled="!isWriting"
            label="공사명(작업명)"
            name="sopName"
            v-model="workPermit.sopName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
          <c-text
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            label="작업내용"
            name="workSummary"
            v-model="workPermit.workSummary">
          </c-text>
        </div>
        <div v-if="!vendorFlag" class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-process
            :disabled="!isWriting"
            :editable="editable"
            label="단위공정"
            name="processCd"
            v-model="workPermit.processCd">
          </c-process>
        </div>
        <div :class="!vendorFlag ? 'col-xs-6 col-sm-4 col-md-2 col-lg-2' : 'col-xs-12 col-sm-12 col-md-4 col-lg-4'">
          <div class="row">
            <div :class="!vendorFlag ? 'col-xs-7 col-sm-7 col-md-7 col-lg-7' : 'col-xs-9 col-sm-9 col-md-9 col-lg-9'">
              <c-text
                :disabled="!isWriting"
                :editable="editable"
                :label="vendorFlag ? '단위공정/작업장소' : '작업장소'"
                name="workLocation"
                v-model="workPermit.workLocation">
              </c-text>
            </div>
            <div :class="!vendorFlag ? 'col-xs-5 col-sm-5 col-md-5 col-lg-5' : 'col-xs-3 col-sm-3 col-md-3 col-lg-3'">
              <!-- <c-checkbox
                :disabled="!isWriting"
                :editable="editable"
                :isFlag="true"
                trueLabel="실외"
                falseLabel="실내"
                label=""
                name="workLocationFlag"
                v-model="workPermit.workLocationFlag"
              /> -->
              <c-select
                :disabled="!isWriting"
                :editable="editable"
                :comboItems="workLocationItems"
                type="none"
                itemText="codeName"
                itemValue="code"
                name="workLocationFlag"
                label=""
                v-model="workPermit.workLocationFlag"
              ></c-select>
            </div>
          </div>
        </div>
        <div v-if="!vendorFlag" class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-equip
            :disabled="!isWriting"
            :editable="editable"
            :plantCd="workPermit.plantCd"
            :processCd="workPermit.processCd"
            label="관련 설비"
            name="equipmentCd"
            v-model="workPermit.equipmentCd"
            @dataChange="equipChange">
          </c-equip>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-vendor
            :disabled="!isWriting"
            :editable="editable"
            label="작업업체"
            name="vendorCd"
            v-model="workPermit.vendorCd"
            @dataChange="vendorChange" />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-select
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SWP_WORK_CLASS_CD"
            type="edit"
            itemText="codeName"
            itemValue="code"
            name="swpWorkClassCd"
            label="작업구분"
            v-model="workPermit.swpWorkClassCd"
          ></c-select>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="!isWriting"
            :editable="editable"
            :phoneNumberCheck="true"
            label="비상연락처"
            name="emergencyContact"
            v-model="workPermit.emergencyContact">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-multi-field
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            :userInfo.sync="userInfo"
            type="dept_user"
            label="담당자"
            beforeText=""
            name="workManagerId"
            v-model="workPermit.workManagerId" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SOP_SAFETY_CERTIFICATION_CD"
            :isObject="true"
            valueText="sopSafetyCertificationName"
            valueKey="sopSafetyCertificationCd"
            label="안전인증 대상설비"
            name="safetyCertifications"
            v-model="workPermit.safetyCertifications"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SOP_AUTO_SAFETY_CONFIRM_CD"
            :isObject="true"
            valueText="sopAutoSafetyConfirmName"
            valueKey="sopAutoSafetyConfirmCd"
            label="자율안전확인신고 대상 설비"
            name="autoSafetyConfirms"
            v-model="workPermit.autoSafetyConfirms"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            :rows="2"
            label="기타요구사항"
            name="specialRequirements"
            v-model="workPermit.specialRequirements">
          </c-textarea>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-radio
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="HAZARD_PREVENTION_PLAN_CD"
            label="유해위험방지계획서"
            name="hazardPreventionPlanCd"
            v-model="workPermit.hazardPreventionPlanCd"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            :isFlag="true"
            label="PSM 관련 여부"
            name="psmFlag"
            v-model="workPermit.psmFlag"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            label="신청인"
            name="request"
            v-model="request">
          </c-text>
        </div>
      </template>
    </c-card>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <c-table
          class="q-mt-md"
          title="안전조치 요구사항"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="workPermit.checkResults"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="checkResultEditable"
          :contentsField="contentsField"
          @table-data-change="tableDataChange"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
        <c-table
          class="q-mt-md"
          title="보호구"
          :columns="grid3.columns"
          :gridHeight="grid3.height"
          :data="workPermit.protectiveGears"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="checkResultEditable"
          :contentsField="contentsField"
          @table-data-change="tableDataChange"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
        <c-table
          ref="gasTable"
          class="q-mt-md"
          title="가스농도 측정"
          :columns="grid2.columns"
          :gridHeight="grid2.height"
          :data="workPermit.gases"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="gasEditable"
          selection="multiple"
          rowKey="sopGasCheckId"
        >
          <!-- <template slot="customTableTitleEditor">
            <q-card class="custom-card no-margin" flat bordered>
              <q-card-section horizontal class="cardhead bg-grey-3">
                <q-card-section class="q-pa-xs">
                  <div class="gas-card-title text-grey-8" style="display:inline;">가스점검</div>
                  <div class="text-caption text-grey q-pl-xs" style="display:inline;">
                    가스농도 측정에 필요한 기기와 점검/확인자를 지정하세요.
                  </div>
                </q-card-section>
              </q-card-section>

              <q-separator />

              <q-card-actions>
                <div class="col-4 gas-item">
                  <c-text
                    :editable="editable"
                    label="점검기기명"
                    name="col1"
                    v-model="workPermit.col1">
                  </c-text>
                </div>
                <div class="col-4 gas-item">
                  <c-text
                    :editable="editable"
                    label="점검자"
                    name="col1"
                    v-model="workPermit.col1">
                  </c-text>
                </div>
                <div class="col-4 gas-item">
                  <c-text
                    :editable="editable"
                    label="확인자(입회자)"
                    name="col1"
                    v-model="workPermit.col1">
                  </c-text>
                </div>
              </q-card-actions>
            </q-card>
          </template> -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="gasEditable" label="추가" icon="add" :showLoading="false" @btnClicked="addGas" />
              <c-btn v-if="gasEditable" label="제외" icon="remove" :showLoading="false" @btnClicked="removeGas" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <c-card title="발급 정보" class="cardClassDetailForm no-margin">
          <template slot="card-detail">
            <div class="col-6">
              <c-field
                :required="true"
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                deptValue="issuedDeptCd"
                type="dept_user"
                label="발급"
                beforeText=""
                name="issuedUserId"
                v-model="workPermit.issuedUserId" />
            </div>
            <div class="col-6">
              <c-field
                :required="true"
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                deptValue="approvalDeptCd"
                type="dept_user"
                label="승인"
                beforeText=""
                name="approvalUserId"
                v-model="workPermit.approvalUserId" />
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <c-card title="안전조치확인 정보" class="cardClassDetailForm no-margin">
          <template slot="card-detail">
            <div class="col-6">
              <c-field
                :required="true"
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                deptValue="maintenanceDeptCheckDeptCd"
                type="dept_user"
                label="공사담당자"
                name="maintenanceDeptCheckUserId"
                v-model="workPermit.maintenanceDeptCheckUserId" />
            </div>
            <div class="col-6">
              <c-field
                :required="true"
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                deptValue="maintenanceDeptEntryDeptCd"
                type="dept_user"
                label="안전보건팀"
                name="maintenanceDeptEntryUserId"
                v-model="workPermit.maintenanceDeptEntryUserId" />
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <c-card title="승인 정보" class="cardClassDetailForm no-margin">
          <template slot="card-detail">
            <div class="col-6">
              <c-field
                :required="true"
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                deptValue="headConstructionDeptCd"
                type="dept_user"
                label="공사 담당부서장"
                beforeText=""
                name="headConstructionDeptUserId"
                v-model="workPermit.headConstructionDeptUserId" />
            </div>
            <!-- <div class="col-6">
              <c-field
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                :plantCd="workPermit.plantCd"
                deptValue="relationCooperation1DeptCd"
                type="dept_user"
                label="협조자-1"
                beforeText=""
                name="relationCooperation1UserId"
                v-model="workPermit.relationCooperation1UserId" />
            </div>
            <div class="col-6">
              <c-field
                :disabled="!isWriting"
                :editable="editable"
                :data="workPermit"
                :plantCd="workPermit.plantCd"
                deptValue="relationCooperation2DeptCd"
                type="dept_user"
                label="협조자-2"
                beforeText=""
                name="relationCooperation2UserId"
                v-model="workPermit.relationCooperation2UserId" />
            </div> -->
          </template>
        </c-card>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from 'quasar'
import eventBus from '@/js/eventBus';
import selectConfig from '@/js/selectConfig';
export default {
  name: 'swp-normal',
  props: {
    workPermit: {
      type: Object,
      default: function() {
        return {
          sopWorkPermitId: '',  // 작업허가서 일련번호
          plantCd: '',  // 사업장 코드
          sopName: '',  // 작업명
          mdmSopId: '',  // 안전작업 표준 일련번호_SOP에서 불러와서 관련 정보 표시후 수정
          permitNo: '',  // 허가번호_(YYYYMMDD-01)
          swpStepCd: '',  // 진행단계 코드
          applicationDeptCd: '',  // 신청인 부서코드
          applicationDeptName: '',
          applicationUserId: '',  // 신청인 ID
          applicationUserName: '',
          workManagerId: '',
          workManagerDeptCd: '',
          emergencyContact: '', // 비상연락처
          permitTypeCd: '',  // 허가서 구분_화기/일반
          permitDate: '',  // 허가일
          workStartTime: '', // 작업시작시간
          workEndTime: '', // 작업종료시간
          workTime: [], // 작업시간
          processCd: '',  // 작업공정
          workLocation: '',  // 작업장소
          workLocationFlag: 'N',  // 작업장소 구분
          equipmentCd: '',  // 설비번호_설비마스터
          workSummary: '',  // 작업개요
          specialRequirements: '',  // 특별요구사항
          maintenanceDeptCheckUserId: '',  // 정비부서 책임자 - 안전조치확인
          maintenanceDeptCheckDeptCd: '',  // 정비부서 책임자 - 안전조치확인
          maintenanceDeptEntryUserId: '',  // 정비부서 입회자 - 안전조치확인
          maintenanceDeptEntryDeptCd: '',  // 정비부서 입회자 - 안전조치확인
          workCompleteTime: '',  // 작업완료시간
          workCompleteEntryUserId: '',  // 작업완료 입회자/확인자
          workCompleteWorkUserId: '',  // 작업완료 작업자
          issuedDeptCd: '',  // 발급자 부서코드
          issuedUserId: '',  // 발급자 ID
          approvalDeptCd: '',  // 승인자 부서코드
          approvalUserId: '',  // 승인자 ID
          relationCooperation1DeptCd: '',  // 관련부서 협조자1 부서코드
          relationCooperation1UserId: '',  // 관련부서 협조자1 ID
          relationCooperation2DeptCd: '',  // 관련부서 협조자2 부서코드
          relationCooperation2UserId: '',  // 관련부서 협조자2 ID
          headConstructionDeptCd: '',  // 공사 담당부서
          headConstructionDeptUserId: '',  // 공사 담당부서장
          vendorCd: '',  // 작업업체 코드
          swpWorkClassCd: null,  // 작업구분 코드
          overWorkFlag: '',  // 연장작업 여부
          psmFlag: 'N',  // PSM 관련 여부
          sopMocId: '',  // MOC 일련번호
          assessWriteUserId: '',  // 작업위험성평가_작성자 ID
          assessApprovalUserId: '',  // 작업위험성평가_승인자 ID
          hazardPreventionPlanCd: '',  // 유해위험방지계획서
          vendorFlag: 0, // 업체작성여부
          regUserId: '',  // 등록자 ID
          chgUserId: '',  // 수정자 ID
          supWorks: [],
          deleteSupWorks: [],
          checkResults: [],
          deleteCheckResults: [],
          gases: [],
          gasChecks: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          maps: [],
          deleteMaps: [],
          workers: [],
          deleteWorkers: [],
          assessments: [],
          deleteAssessments: [],
          overs: [],
          deleteOvers: [],
          protectiveGears: [],
          deleteProtectiveGears: [],
          safetyCertifications: [],
          autoSafetyConfirms: [],
          apprUsers: [],

          isClosedSpaceEquip: false,
        }
      }
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    isWriting: {
      type: Boolean,
      default: false,
    },
    saveCall: {
      type: Object,
      default: function() {
        return {
          saveCallData: '',
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isApprUser: {
      type: Boolean,
      default: false,
    },
    checkResultEditable: {
      type: Boolean,
      default: false,
    },
    gasEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: '450px'
      },
      grid2: {
        columns: [],
        height: '450px'
      },
      grid3: {
        columns: [
          {
            name: 'sopProtectiveGearName',
            field: 'sopProtectiveGearName',
            label: '보호구',
            align: 'left',
            sortable: true,
          },
          {
            name: 'necessaryFlag',
            field: 'necessaryFlag',
            label: '필요',
            align: 'center',
            sortable: false,
            type: 'check',
            'true': 'Y',
            'false': 'N',
            value: 'N',
            setHeader: true,
          },
          {
            name: 'confirmFlag',
            field: 'confirmFlag',
            label: '확인',
            align: 'center',
            sortable: false,
            type: 'check',
            disableTarget: 'necessaryFlag',
            disableCon: 'Y',
            'true': 'Y',
            'false': 'N',
            value: 'N',
            setHeader: true,
          },
        ],
        height: '450px'
      },
      workLocationItems: [
        { code: 'N', codeName: '실내', },
        { code: 'Y', codeName: '실외', },
        { code: 'S', codeName: '실내+실외', },
      ],
      useGasItems: [],
      sopEditing: false,
      editable: true,
      listCheckItemUrl: '',
      listGasItemUrl: '',
      listSopUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    request() {
      return this.workPermit.applicationDeptName + ' / ' + this.workPermit.applicationUserName
    },
    isSopEdit() {
      return Boolean(!this.workPermit.mdmSopId && this.workPermit.sopName) || this.sopEditing
    },
    userInfo() {
      let userItems = [];
      if (this.workPermit.workManagerId && this.workPermit.workManagerId.length > 0) {
        let data = this.$_.split(this.workPermit.workManagerId, ',');
        this.$_.forEach(data, item => {
          userItems.push({
            userValue: item
          })
        })
      }
      return {
        userItems: userItems,
        userText: 'workManagerName',
        userValue: 'workManagerId',
        deptText: 'workManagerDeptName',
        deptValue: 'workManagerDeptCd',
      }
    },
    vendorFlag() {
      return this.workPermit.vendorFlag > 0;
    },
  },
  watch: {
    'workPermit.plantCd'() {
      this.$set(this.workPermit, 'checkResults', [])
      this.$set(this.workPermit, 'gases', [])
      this.getCheckItemList();
      this.getGasItemList();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    eventBus.$on('vaildForm', (type)=>{
      if (this.$refs['editForm']) {
        this.$refs['editForm'].validate().then(_result => {
          this.$emit('validResult', _result, type);
        });
      }
    });
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listCheckItemUrl = selectConfig.sop.swp.workChekItem.list.url
      this.listGasItemUrl = selectConfig.sop.swp.gas.list.url
      this.listSopUrl = selectConfig.mdm.sop.jobhazard.url;
      // code setting
      if (!this.workPermit.protectiveGears || this.workPermit.protectiveGears.length === 0) {
        this.$comm.getComboItems('SOP_PROTECTIVE_GEAR_CD').then(_result => {
          if (_result && _result.length > 0) {
            this.$_.forEach(_result, item => {
              this.workPermit.protectiveGears.push({
                sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                sopProtectiveGearCd: item.code,  // 보호구 코드
                sopProtectiveGearName: item.codeName,  // 보호구
                necessaryFlag: 'N',  // 필요
                confirmFlag: 'N',  // 확인
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                editFlag: 'C',
              })
            })
          }
        });
      }
      // list setting
      this.getCheckItemList();
      this.getGasItemList();
    },
    getCheckItemList() {
      /**
       * default 값을 조회
       * 
       * 초기인 경우 workPermit.checkResults에 값을 그대로 적용
       * 작성중 단계인 경우 default 값에 새로운 항목이 있을시에 workPermit.checkResults에 추가하여 입력을 받을 수 있도록 조치
       * 승인완료, 연장, 취소, 작업완료인 경우 저장된 데이터를 그대로 표시하며 이 경우 default값을 조회하지 않도록 조치
       */
      this.grid.columns = [
        {
          name: 'checkItemName',
          field: 'checkItemName',
          label: '항목',
          align: 'left',
          sortable: true,
        },
        {
          name: 'necessaryFlag',
          field: 'necessaryFlag',
          label: '필요',
          align: 'center',
          sortable: false,
          type: 'check',
          'true': 'Y',
          'false': 'N',
          value: 'N',
          setHeader: true,
        },
        {
          name: 'confirmFlag',
          field: 'confirmFlag',
          label: '확인',
          align: 'center',
          sortable: false,
          type: 'check',
          disableTarget: 'necessaryFlag',
          disableCon: 'Y',
          'true': 'Y',
          'false': 'N',
          value: 'N',
          setHeader: true,
        },
      ]
      if (!this.workPermit.plantCd) return;
      if (!this.workPermit.checkResults) this.workPermit.checkResults = [];
      if (!this.isOld || this.workPermit.swpStepCd === 'SS00000001') {
        this.$http.url = this.listCheckItemUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.workPermit.plantCd,
          sopWorkTypeCd: 'SWT0000001',
          useFlag: 'Y',
        }
        this.$http.request((_result) => {
          if (!this.isOld) {
            // 최초인 경우 조치항목을 가지고 있지 않음으로 해당 값을 표시
            this.$_.forEach(_result.data, item => {
              this.workPermit.checkResults.push({
                sopWorkPermitId: '',  // 작업허가서 일련번호
                supplementWorkTypeCd: '',  // 보충작업구분
                sopCheckItemId: item.sopCheckItemId,  // 점검항목 일련번호
                checkItemName: item.checkItemName, // 점검항목명
                sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                necessaryFlag: 'N',  // 필요
                confirmFlag: 'N',  // 확인
                confirmUserId: '',  // 확인자
                confirmUserName: '',  // 확인자명
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                chgUserId: '',  // 수정자 ID
                editFlag: 'C'
              })
            })
          } else {
            this.$_.forEach(_result.data, item => {
              if (this.$_.findIndex(this.workPermit.checkResults, { sopCheckItemId: item.sopCheckItemId }) === -1) {
                this.workPermit.checkResults.push({
                  sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                  supplementWorkTypeCd: '',  // 보충작업구분
                  sopCheckItemId: item.sopCheckItemId,  // 점검항목 일련번호
                  checkItemName: item.checkItemName, // 점검항목명
                  sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                  necessaryFlag: 'N',  // 필요
                  confirmFlag: 'N',  // 확인
                  confirmUserId: '',  // 확인자
                  confirmUserName: '',  // 확인자명
                  regUserId: this.$store.getters.user.userId,  // 등록자 ID
                  chgUserId: '',  // 수정자 ID
                  editFlag: 'C'
                })
              }
            })
          }
          
          if (this.$_.findIndex(_result.data, { sopCheckItemKindCd: 'SCIK000005' }) > -1 
            || this.$_.findIndex(this.workPermit.checkResults, { sopCheckItemKindCd: 'SCIK000005' }) > -1) {
            this.grid.columns.push({
              name: 'confirmUserName',
              field: 'confirmUserName',
              label: '확인자',
              align: 'center',
              sortable: false,
              type: 'user',
              userId: 'confirmUserId',
              disableTarget: 'necessaryFlag',
              disableCon: 'Y',
            })
          }
        },);
      } else {
        if (this.$_.findIndex(this.workPermit.checkResults, { sopCheckItemKindCd: 'SCIK000005' }) > -1) {
          this.grid.columns.push({
            name: 'confirmUserName',
            field: 'confirmUserName',
            label: '확인자',
            align: 'center',
            sortable: false,
            type: 'user',
            userId: 'confirmUserId',
            disableTarget: 'necessaryFlag',
            disableCon: 'Y',
          })
        }
      }
    },
    getGasItemList() {
      let columns = [
        {
          name: 'gasCheckMachine',
          field: 'gasCheckMachine',
          label: '측정장소',
          align: 'center',
          sortable: false,
          type: 'text',
          value: '',
          setHeader: true,
          style: 'width:15%',
        },
        {
          name: 'checkTime',
          field: 'checkTime',
          label: '측정시간',
          align: 'center',
          type: 'datetime',
          minuteStep: 1,
          sortable: false,
          style: 'width:15%',
        },
        {
          name: 'gasCheckUserName',
          field: 'gasCheckUserName',
          label: '측정자',
          align: 'center',
          sortable: false,
          type: 'user',
          userId: 'gasCheckUserId',
          value: '',
          setHeader: true,
          style: 'width:10%',
        },
        // {
        //   name: 'gasConfirmUserName',
        //   field: 'gasConfirmUserName',
        //   label: '확인자',
        //   align: 'center',
        //   sortable: false,
        //   type: 'user',
        //   userId: 'gasConfirmUserId',
        //   value: '',
        //   setHeader: true,
        //   style: 'width:10%',
        // },
      ];

      if (!this.workPermit.plantCd) return;
      this.$http.url = this.listGasItemUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.workPermit.plantCd,
        // sopWorkTypeCd: 'SWT0000001',
      }
      this.$http.request((_result) => {
        this.useGasItems = [];
        if (this.workPermit.gases && this.workPermit.gases.length > 0) {
          let pushData = [];
          this.$_.forEach(this.workPermit.gases, gas => {
            for (let gasValue in gas) {
              let idx = this.$_.findIndex(_result.data, { sopGasId: gasValue });
              let idx2 = this.$_.findIndex(pushData, { sopGasId: gasValue });
              /**
               * idx의 경우 기본적으로 존재하는지 여부를 판단하지만
               *            예전 입력된 값 중 useFlag N처리된 값이 있는 경우는 허용
               */
              if ((idx > -1 && gas[gasValue] !== '-') && idx2 === -1) {
                this.$set(_result.data[idx], 'me')
                pushData.push(_result.data[idx])
              }
            }
          })
          if (pushData && pushData.length > 0) {
            this.$_.forEach(pushData, item => {
              this.useGasItems.push(item)
              columns.splice(2, 0, {
                // 가스 헤더 적용 로직 추가 필요
                name: item.sopGasId + '_p',
                field: item.sopGasId + '_p',
                label: item.gasName,
                align: 'center',
                sortable: false,
                child: [
                  {
                    name: item.sopGasId,
                    field: item.sopGasId,
                    label: item.safetyStandards,
                    align: 'center',
                    type: 'text',
                    sortable: false,
                    style: 'width:' + (50 / pushData.length) + '%',
                  },
                ]
              })
            })
          }
        } else {
          let useYList = this.$_.filter(_result.data, item => {
            return item.useFlag === 'Y' // && this.$_.findIndex(item.workTypes, { sopWorkTypeCd: 'SWT0000001' }) > -1
          });
          this.$_.forEach(useYList, gas => {
            this.useGasItems.push(gas)
            columns.splice(2, 0, {
              // 가스 헤더 적용 로직 추가 필요
              name: gas.sopGasId + '_p',
              field: gas.sopGasId + '_p',
              label: gas.gasName,
              align: 'center',
              sortable: false,
              child: [
                {
                  name: gas.sopGasId,
                  field: gas.sopGasId,
                  label: gas.safetyStandards,
                  align: 'center',
                  type: 'text',
                  sortable: false,
                  style: 'width:' + (50 / useYList.length) + '%',
                },
              ]
            })
          })
        }

        this.grid2.columns = columns
      },);
    },
    addGas() {
      let pushData = {
        sopGasCheckId: uid(),  // 가스농도측정번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
        supplementWorkTypeCd: '',  // 보충작업구분
        checkTime: '',  // 점검시간
        gasCheckMachine: '',  // 점검기기명
        gasCheckUserName: '',
        gasCheckUserId: '',  // 점검자
        gasConfirmUserName: '',
        gasConfirmUserId: '',  // 확인자(입회자)
        regUserId: this.$store.getters.user.userId,  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        editFlag: 'C',
      }
      this.$_.forEach(this.useGasItems, gas => {
        this.$set(pushData, gas.sopGasId, '0');
      });
      
      this.workPermit.gases.push(pushData);
    },
    removeGas() {
      let selectData = this.$refs['gasTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '제외할 행을 지정하세요.', // 제외할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.workPermit.deleteGasChecks) this.workPermit.deleteGasChecks = [];
        if (!this.workPermit.deleteGasCheckVals) this.workPermit.deleteGasCheckVals = [];
        this.$_.forEach(selectData, item => {
          if (this.$_.findIndex(this.workPermit.deleteGasChecks, { sopGasCheckId: item.sopGasCheckId }) === -1
            && item.editFlag !== 'C') {
            this.workPermit.deleteGasChecks.push(item);
            this.$_.forEach(this.useGasItems, gas => {
              this.workPermit.deleteGasCheckVals.push({
                sopGasCheckId: item.sopGasCheckId,
                sopGasId: gas.sopGasId
              })
            })
          }
          this.workPermit.gases = this.$_.reject(this.workPermit.gases, item);
          this.$refs['gasTable'].$refs['compo-table'].clearSelection();
        });
      }
    },
    tableDataChange(props, col) {
      if (col.name === 'necessaryFlag' && props.row[col.name] !== 'Y') {
        this.$set(props.row, 'confirmFlag', 'N');
      }
    },
    vendorChange(vendorCd, beforeVendorCd) {
      if (vendorCd === 'VEN0000000') {
        this.workPermit.swpWorkClassCd = 'SWC0000005'
      } else if (vendorCd) {
        this.workPermit.swpWorkClassCd = 'SWC0000001'
      }
      if (this.workPermit.workers && this.workPermit.workers.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '해당 작업업체별로 지정된 작업자 정보들이 제외됩니다.\n\r진행하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            if (!this.workPermit.deleteWorkers) {
              this.workPermit.deleteWorkers = [];
            }
            this.$_.forEach(this.$_.filter(this.workPermit.workers, { vendorCd: beforeVendorCd }), item => {
              if (this.$_.findIndex(this.workPermit.deleteWorkers, { sopWorkerId: item.sopWorkerId }) === -1) {
                this.workPermit.deleteWorkers.push(item)
              }
            })
            this.workPermit.workers = this.$_.reject(this.workPermit.workers, { vendorCd: beforeVendorCd })
          },
          // 취소 callback 함수
          cancelCallback: () => {
            this.$set(this.workPermit, 'vendorCd', beforeVendorCd)
          },
        });
      }
    },
    sopEdit() {
      if (this.workPermit.assessments && this.workPermit.assessments.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '작업을 수기로 작성할 시에\n\r작업위험성평가에 작성된 안전조치사항이 초기화 됩니다.\n\r진행하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(this.workPermit.assessments, item => {
              if (item.editFlag !== 'C'
                && this.$_.findIndex(this.workPermit.deleteAssessments, { sopWorkSopAssessmentId: item.sopWorkSopAssessmentId }) === -1) {
                this.workPermit.deleteAssessments.push(item)
              }
            });
            this.workPermit.assessments = [];
            
            this.sopEditing = true
            this.workPermit.mdmSopId = null;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        this.sopEditing = true
        this.workPermit.mdmSopId = null;
      }
    },
    searchSop() {
      if (this.workPermit.processCd) {
        if (this.workPermit.assessments && this.workPermit.assessments.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '작업을 변경할 시에\n\r작업위험성평가에 작성된 안전조치사항이 변경 됩니다.\n\r진행하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.openSopPopup();
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          this.openSopPopup();
        }
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '공정을 지정하신 후 이용바랍니다.', // 공정을 지정하신 후 이용바랍니다.
          type: 'warning', // success / info / warning / error
        });
      }
    },
    openSopPopup() {
      this.popupOptions.title = 'SOP 검색'; // SOP 검색
      this.popupOptions.param = {
        type: 'single',
        searchType: '1',
        subProcessCd: this.workPermit.processCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/common/process/sopPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeSopPopup;
    },
    closeSopPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        if (this.workPermit.assessments && this.workPermit.assessments.length > 0) {
          if (!this.workPermit.deleteAssessments) {
            this.workPermit.deleteAssessments = [];
          }
          this.$_.forEach(this.workPermit.assessments, item => {
            if (item.editFlag !== 'C'
              && this.$_.findIndex(this.workPermit.deleteAssessments, { sopWorkSopAssessmentId: item.sopWorkSopAssessmentId }) === -1) {
              this.workPermit.deleteAssessments.push(item)
            }
          });
        }
        if (this.workPermit.mdmSopId !== data[0].mdmSopId) {
          this.$http.url = this.listSopUrl;
          this.$http.type = 'GET';
          this.$http.param = {
            mdmSopId: data[0].mdmSopId,
          }
          this.$http.request((_result) => {
            this.$_.forEach(_result.data, item => {
              item.sopWorkSopAssessmentId = uid();  // 작업허가서_작업위험성평가_일련번호
              item.sopWorkPermitId = this.workPermit.sopWorkPermitId;  // 작업허가서 일련번호
              // item.jobStepName = item.jobStepName;  // 작업단계 명
              // item.riskHazardName = item.riskHazardName;  // 유해위험요인명
              item.safetyActionMeasures = '';  // 안전조치사항
              item.actionEducationFlag = 'N';  // 조치/교육완료여부
              item.beforeFrequency = null,  // 개선전 빈도
              item.beforeStrength = null,  // 개선전 강도
              item.beforeRisk = null,  // 개선전 위험도
              item.afterFrequency = null,  // 개선후 빈도
              item.afterStrength = null,  // 개선후 강도
              item.afterRisk = null,  // 개선후 위험도
              item.regUserId = this.$store.getters.user.userId;  // 등록자 ID
              item.chgUserId = '';  // 수정자 ID
              item.editFlag = 'C'
            })
            this.workPermit.assessments = _result.data;
          },);
          this.sopEditing = false
          this.workPermit.mdmSopId = data[0].mdmSopId
          this.workPermit.sopName = data[0].sopName
        }
      }
    },
    removeSop() {
      if (this.workPermit.assessments && this.workPermit.assessments.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '작업을 변경할 시에\n\r작업위험성평가에 작성된 안전조치사항이 초기화 됩니다.\n\r진행하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$_.forEach(this.workPermit.assessments, item => {
              if (item.editFlag !== 'C'
                && this.$_.findIndex(this.workPermit.deleteAssessments, { sopWorkSopAssessmentId: item.sopWorkSopAssessmentId }) === -1) {
                this.workPermit.deleteAssessments.push(item)
              }
            });
            this.workPermit.assessments = [];
            
            this.sopEditing = false
            this.workPermit.mdmSopId = null
            this.workPermit.sopName = null
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        this.sopEditing = false
        this.workPermit.mdmSopId = null
        this.workPermit.sopName = null
      }
    },
    contentsField(props, col) {
      /**
       * 안전조치사항 항목에서 항목 입력 타입이 '테이블_점검자' 인 경우 테이블에 표시
       * 단, 예전에 '테이블_점검자'였으며 그럼으로 인해 데이터가 저장이 된적이 있는 경우 컴포넌트 표시
       */
      let returnVal = true;
      if (col.name === 'confirmUserName') {
        returnVal = props.row['sopCheckItemKindCd'] === 'SCIK000005' || Boolean(props.row['confirmUserName'])
      }
      return returnVal
    },
    equipChange(equip) {
      if (equip.closedSpaceFlag === 'Y') {
        this.workPermit.isClosedSpaceEquip = true;
      } else {
        this.workPermit.isClosedSpaceEquip = false;
      }
    }
  }
};
</script>
<style lang="sass">
.workpermit-worker-info
  margin-left: 0.5em !important
  margin-right: 0 !important
  .q-avatar__content
    font-size: 0.8em
    line-height: 0.8em
.gas-item
  padding-top:18px !important
  .q-field__inner
    padding-bottom: 0px !important
  .customText
    padding-bottom: 0px !important
.gas-card-title
  font-size: 15px
  font-weight: 800
</style>